import ScrollAnimation from 'react-animate-on-scroll';
import styled from 'styled-components';
import { Typography } from '~/components';
import { getTheme } from '~/utils';

const smallSpacing = getTheme('smallSpacing');
const mediumSpacing = getTheme('mediumSpacing');
const sectionSpacing = getTheme('sectionSpacing');
const giantSpacing = getTheme('giantSpacing');
const inMobileAndTablet = getTheme('inMobileAndTablet');

export const Wrapper = styled.div`
  display: flex !important;
  flex-direction: column;
  flex: 1;
  align-items: center;
  margin: ${giantSpacing} ${sectionSpacing};
  @media ${inMobileAndTablet} {
    margin: ${mediumSpacing};
  }
`;

export const ContentWrapper = styled.div`
  display: flex !important;
  flex-direction: row;
  min-height: 20vh;
  @media ${inMobileAndTablet} {
    flex-direction: column;
    justify-content: center;
  }
`;

export const ImageWrapper = styled(ScrollAnimation).attrs({
  animateIn: 'fadeInRight',
})`
  width: 50%;
  display: flex !important;
  justify-content: center;
  align-items: center;
  @media ${inMobileAndTablet} {
    width: 100%;
    margin: ${sectionSpacing} 0;
  }
`;
export const TextWrapper = styled(ScrollAnimation).attrs({
  animateIn: 'fadeInLeft',
})`
  justify-content: center;
  align-items: center;
  width: 50%;
  @media ${inMobileAndTablet} {
    width: 100%;
  }
`;

export const Title = styled(Typography).attrs({ variant: 'h4' })`
  font-family: Poppins;
  font-size: 33px;
  line-height: 19px;
  font-weight: 300;
  text-align: center;
`;

export const Text = styled(Typography).attrs({ variant: 'body1' })`
  font-family: Poppins;
  line-height: 29px;
  font-weight: 300;
  margin-top: ${smallSpacing};
  color: rgba(45, 48, 50, 0.75);
  @media ${inMobileAndTablet} {
    text-align: justify;
  }
`;

export const Image = styled.img`
  width: 70%;
  @media ${inMobileAndTablet} {
     width: 90%;
  }
  /* height: 90%; */
`;
